export const STACK = [
  { name: "TypeScript", cat: "lang", n: "01" },
  { name: "JavaScript", cat: "lang", n: "02" },
  { name: "PHP", cat: "lang", n: "03" },
  { name: "Dart", cat: "lang", n: "04" },
  { name: "NestJS", cat: "backend", n: "05" },
  { name: "Laravel", cat: "backend", n: "06" },
  { name: "Next.js", cat: "frontend", n: "07" },
  { name: "React", cat: "frontend", n: "08" },
  { name: "Flutter", cat: "mobile", n: "09" },
  { name: "TailwindCSS", cat: "frontend", n: "10" },
  { name: "CSS · SASS", cat: "frontend", n: "11" },
  { name: "Node.js", cat: "backend", n: "12" },
  { name: "REST · GraphQL", cat: "api", n: "13" },
  { name: "PostgreSQL", cat: "data", n: "14" },
  { name: "MySQL", cat: "data", n: "15" },
  { name: "MongoDB", cat: "data", n: "16" },
  { name: "Redis", cat: "cache", n: "17" },
  { name: "Kafka", cat: "events", n: "18" },
  { name: "Docker", cat: "devops", n: "19" },
  { name: "CI / CD", cat: "devops", n: "20" },
];

export const EXPERIENCES = [
  {
    when: "2024 — present",
    now: true,
    company: "Asernum",
    role: {
      fr: "Senior Fullstack · Lead sur plusieurs produits.",
      en: "Senior Fullstack · Lead on multiple products.",
    },
    notes: {
      fr: "Conception et delivery de produits SaaS et publics : <strong>FIBB</strong>, <strong>E-Justice CI</strong>, <strong>FER GAB</strong>, <strong>Auchan Club</strong>, <strong>Asend</strong>. Architecture, lead front/back, code review et coaching de l'équipe.",
      en: "Design and delivery of SaaS and public products: <strong>FIBB</strong>, <strong>E-Justice CI</strong>, <strong>FER GAB</strong>, <strong>Auchan Club</strong>, <strong>Asend</strong>. Architecture, front/back lead, code review and team coaching.",
    },
    tags: [ "NestJS", "Laravel", "Next.js","Postgres", "Mongo",  "MySQL", "Redis", "Kafka", "Docker"],
  },
  {
    when: "2023 — 2024",
    company: "KKS Technologies",
    role: {
      fr: "Fullstack · Lead Backend",
      en: "Fullstack · Lead Backend",
    },
    notes: {
      fr: "Lead backend sur <strong>BARM</strong>, <strong>Car225</strong> et plusieurs apps métier. Modélisation domaine, API REST robustes, intégrations tierces, migrations DB lourdes en zéro downtime.",
      en: "Backend lead on <strong>BARM</strong>, <strong>Car225</strong> and several business apps. Domain modeling, robust REST APIs, third-party integrations, heavy zero-downtime DB migrations.",
    },
    tags: ["NestJs", "Laravel", "Next.js", "Flutter", "Postgres", "MySQL", "Redis", "Docker"],
  },
  {
    when: "2021 — 2023",
    company: "Innovat Consulting",
    role: {
      fr: "Fullstack",
      en: "Fullstack",
    },
    notes: {
      fr: "Premières grosses missions client. Conception et Chef de Projets des applications Daymond (<strong>Daymond Distribution</strong> et <strong>Daymond collaboration</strong> disponible sur le PlayStore et AppleStore). Apprentissage du delivery dans un contexte de service.",
      en: "First major client projects. Design and Project Management of the Daymond apps (<strong>Daymond Distribution</strong> and <strong>Daymond collaboration</strong> available on the Play Store and App Store). Learning delivery in a service context.",
    },
    tags: ["PHP", "JavaScript", "Dart", "Laravel", "Flutter", "MySQL"],
  },
];

export const PROJECTS = [
  {
    id: "01",
    name: "FIBB",
    desc: {
      fr: "Plateforme de la Fédération Ivoirienne de BasketBall. Architecture multi-tenant, sécurité et conformité au cœur.",
      en: "Platform of the Ivorian Basketball Federation. Multi-tenant architecture, security and compliance at the core.",
    },
    role: "Asernum - Lead Fullstack",
    // href: "https://fibb.app",
    href: "#",
    live: true,
    sigil: "FB",
  },
  {
    id: "02",
    name: "E-Justice CI",
    desc: {
      fr: "Portail officiel de la Justice Ivoirienne. Forte volumétrie, exigences de fiabilité et de sécurité élevées.",
      en: "Official portal of Ivorian Justice. High-volume platform with high reliability and security requirements.",
    },
    role: "Asernum - Backend",
    href: "https://e-justice.ci",
    live: true,
    sigil: "JC",
  },
  {
    id: "03",
    name: "CGRAE",
    desc: {
      fr: "Plateforme d'enrôlement et de collecte de preuve de vie des assurés CGRAE. Gestion des dossiers, workflows administratifs et interface de saisie terrain.",
      en: "Enrollment and proof-of-life collection platform for CGRAE insured persons. File management, administrative workflows and field input interface.",
    },
    role: "Asernum - Backend",
    href: null,
    live: true,
    sigil: "CG",
  },
  {
    id: "04",
    name: "FER GAB",
    desc: {
      fr: "Outils internes pour l'infrastructure du Fonds d'Entretien Routier pour la Gestion des achats, decaissements.",
      en: "Internal tools for the Road Maintenance Fund infrastructure — purchase and disbursement management.",
    },
    role: "Asernum - Lead Technique",
    href: null,
    live: false,
    sigil: "FR",
  },
  {
    id: "05",
    name: "Auchan Club",
    desc: {
      fr: "App de fidélité distribuée sur Play Store et App Store. Architecture multi-couche : admin web, application mobile et services backend.",
      en: "Loyalty app distributed on Play Store and App Store. Multi-layer architecture: web admin, mobile app and backend services.",
    },
    role: "Asernum - Lead Backend",
    href: "https://play.google.com/store/apps/details?id=com.asernum.auchan_client&hl=fr",
    live: true,
    sigil: "AC",
  },
  {
    id: "06",
    name: "Asend",
    desc: {
      fr: "Service de Fournisseur de SMS dans l'écosystème Aspace. Focus performance et UX.",
      en: "SMS Provider service in the Aspace ecosystem. Focus on performance and UX.",
    },
    role: "Asernum - Lead Backend",
    // href: "https://asend.aspace.verif.ci/",
    href: "#",
    live: true,
    sigil: "AS",
  },
  {
    id: "07",
    name: "BARM",
    desc: {
      fr: "Plateforme du Ministère de Défense. Modélisation complexe, intégrations externes critiques.",
      en: "Ministry of Defense platform. Complex domain modeling, critical external integrations.",
    },
    role: "KKS Technologies - Lead Fullstack",
    href: "https://barm-app.com/",
    live: true,
    sigil: "BM",
  },
];

export const SERVICES = [
  {
    n: "01",
    title: { fr: "Build from scratch", en: "Build from scratch" },
    desc: {
      fr: "Tu as une idée. Je conçois l'architecture, je code, je livre. Stack au choix selon le contexte — pas de dogme.",
      en: "You have an idea. I design the architecture, write the code, deliver. Stack chosen based on context — no dogma.",
    },
    list: {
      fr: ["Spec produit", "Architecture & schéma", "Front + Back + Mobile", "Déploiement initial"],
      en: ["Product spec", "Architecture & schema", "Front + Back + Mobile", "Initial deployment"],
    },
  },
  {
    n: "02",
    title: { fr: "Lead / scale équipe", en: "Lead / scale team" },
    desc: {
      fr: "Reprise d'un produit existant : audit, dette technique, mentorat de l'équipe, mise en place des bonnes pratiques.",
      en: "Taking over an existing product: audit, technical debt, team mentoring, implementation of best practices.",
    },
    list: {
      fr: ["Audit code & infra", "Code review", "Mise en place CI/CD", "Coaching mid/junior"],
      en: ["Code & infra audit", "Code review", "CI/CD setup", "Mid/junior coaching"],
    },
  },
  {
    n: "03",
    title: { fr: "Mission ponctuelle", en: "Targeted mission" },
    desc: {
      fr: "Une feature critique à livrer, une migration de DB, un bug structurel. Je rentre, je débloque, je documente.",
      en: "A critical feature to ship, a DB migration, a structural bug. I come in, unblock, document.",
    },
    list: {
      fr: ["Refactor ciblé", "Migration DB", "Performance & cache", "Intégration tierce"],
      en: ["Targeted refactor", "DB migration", "Performance & cache", "Third-party integration"],
    },
  },
];

export const STATS = [
  { num: "5",  small: "+y", label: { fr: "Années d'expérience", en: "Years of experience" } },
  { num: "30", small: "+", label: { fr: "Projets livrés", en: "Projects shipped" } },
  { num: "4",  small: "",  label: { fr: "Entreprises · 2 freelance", en: "Companies · 2 freelance" } },
  { num: "∞",  small: "",  label: { fr: "Bugs corrigés", en: "Bugs fixed" } },
];
